import React from 'react';
import { 
  User, 
  Users, 
  Edit2,
  Trash2,
} from 'lucide-react';

const ClassCard = ({ classData, onEdit, onDelete, onAssign, onView }) => {
  const { unitName, code, assignedTeachers, _id, studentCount = 0 } = classData;
  const teacherName = assignedTeachers?.userName || assignedTeachers?.name;
  
  return (
    <div 
      onClick={() => onView(classData)}
      className="group bg-white rounded-2xl border border-gray-100 hover:border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden cursor-pointer relative flex flex-col h-full"
    >
      {/* Action Buttons (Subtle) */}
      <div className="absolute top-3 right-3 flex gap-1 opacity-0 group-hover:opacity-100 transition-all duration-200">
        <button 
          onClick={(e) => { e.stopPropagation(); onEdit(classData); }}
          className="p-1.5 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-md transition-colors"
          title="Edit"
        >
          <Edit2 size={14} />
        </button>
        <button 
          onClick={(e) => { e.stopPropagation(); onDelete(_id); }}
          className="p-1.5 text-gray-400 hover:text-rose-600 hover:bg-rose-50 rounded-md transition-colors"
          title="Delete"
        >
          <Trash2 size={14} />
        </button>
      </div>

      <div className="p-5 flex flex-col flex-1">
        {/* Header Section */}
        <div className="mb-4">
          <div className="inline-flex items-center justify-center p-2 bg-indigo-50 text-indigo-600 rounded-lg mb-3">
             <span className="text-xs font-bold uppercase tracking-wider">
                {unitName.substring(0, 2).toUpperCase()}
             </span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 leading-snug line-clamp-2 mb-1 group-hover:text-indigo-600 transition-colors">
            {unitName}
          </h3>
          {code ? (
            <p className="text-xs text-gray-500 font-medium">Code: {code}</p>
          ) : (
            <p className="text-xs text-gray-400 italic">No code assigned</p>
          )}
        </div>

        <div className="mt-auto pt-4 border-t border-gray-50 flex items-center justify-between">
           {/* Teacher Info */}
           <div 
             onClick={(e) => { e.stopPropagation(); onAssign(classData); }}
             className="flex items-center gap-2.5 cursor-pointer hover:bg-gray-50 p-1.5 -ml-1.5 rounded-lg transition-colors max-w-[65%]"
           >
              <div className={`h-6 w-6 rounded-full flex-shrink-0 flex items-center justify-center text-[10px] font-bold ${teacherName ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-400'}`}>
                {teacherName ? teacherName[0].toUpperCase() : <User size={12} />}
              </div>
              <span className={`text-xs font-medium truncate ${teacherName ? 'text-gray-700' : 'text-gray-400 italic'}`}>
                {teacherName || 'Assign Teacher'}
              </span>
           </div>

           {/* Student Count */}
           <div className="flex items-center gap-1.5 text-gray-500 bg-gray-50 px-2 py-1 rounded-md">
              <Users size={12} />
              <span className="text-xs font-bold text-gray-700">{studentCount}</span>
           </div>
        </div>
      </div>
    </div>
  );
};

export default ClassCard;
